module.exports = __webpack_public_path__ + "media/Sweety - 樱花草.ddbab50e.flac";